







































import { Component, Prop, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { AxiosResponse } from 'axios'
import { EventBus, FILE_RENAMED } from '@/plugins/eventBus'
import { ApiError } from '@/definitions/apiError'

@Component({
  name: 'file-rename-modal',
  components: {}
})
export default class FileRenameModal extends Vue {
  @Prop()
  fileName: string

  isLoading = false
  errorMessages: string[] = []
  textInput = this.fileName

  rename () {
    this.isLoading = true

    axiosInstance.put('/files', {
      fileName: this.fileName,
      newFileName: this.textInput
    })
      .then((response: AxiosResponse) => {
        const r = response.data
        EventBus.$emit(FILE_RENAMED, { oldFileName: this.fileName, newFileName: r.fileName })
        this.$emit('close')
      })
      .catch((error: ApiError) => {
        if (error.errors) {
          this.errorMessages = error.errors.map(err => err.message)
        } else {
          this.errorMessages = [error.message]
        }
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
